<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card no-shadow no-radius class="list-view-item overflow-hidden" v-on="$listeners">

        <template slot="no-body">
            <div class="bg-success px-10 py-2 text-white text-bold text-center" style="width: 200px; position: absolute; top: -10px; right: -50px; transform: rotate(45deg);" v-show="onSale">PROMOCIÓN<br/><b>Antes Q{{ item.price }}</b></div>
            <div class="vx-row item-details no-gutter">

                <!-- IMG COL -->
                <div class="flex vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center cursor-pointer" @click="goToItem">
                    <img :src="getImage(item, imageHeight)" :alt="item.name" class="grid-view-img p-4 mx-auto" rel="preload">
<!--
                  <cld-image
                    :cloudName="cloudName"
                    :publicId="`products/${item.id}/${item.isbn}.png`"
                    :height="imageHeight"
                    width="auto"
                    class="mx-auto"
                  />
-->
                </div>

                <!-- ITEM NAME & DESC COL -->
                <div class="vx-col sm:w-1/2">
                    <div class="p-4 pt-6">
                        <slot name="item-meta">
                            <h6 class="item-name font-semibold mb-1 hover:text-primary cursor-pointer" @click="goToItem">{{ item.name }}</h6>
<!--                            <p class="text-sm mb-4">By <span class="font-semibold cursor-pointer">{{ item.brand }}</span></p>-->
                            <p class="item-description text-sm">{{ item.description }}</p>
                          <ul v-if="item.combo">
                            <li v-for="option in item.couponOptions" :key="option.id">
                              <small class="truncate mb-2"><b>{{ option.name }}</b></small>
                              <ul>
                                <li v-for="productOption in option.products" :key="productOption.id">
                                  <small class="truncate mb-2">{{ productOption.qtySelected }} {{ productOption.name }}</small>
                                </li>
                              </ul>
                              <br>
                            </li>
                          </ul>
                        </slot>
                    </div>
                </div>

                <!-- PURCHASE COL -->
                <div class="vx-col sm:w-1/4 w-full flex items-center sm:border-l border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

                    <div class="p-4 flex flex-col w-full">

<!--                        <div class="text-warning flex self-end border border-solid border-warning py-1 px-2 rounded">-->
<!--                            <span class="text-sm mr-1">{{ item.rating }}</span>-->
<!--                            <feather-icon icon="StarIcon" svgClasses="h-4 w-4" />-->
<!--                        </div>-->

                        <div class="my-6">
                            <h5 class="font-bold text-center text-xl">Q{{ item.amount.toFixed(2) }}</h5>
<!--                            <span class="text-grey flex items-start justify-center mt-1" v-if="item.free_shipping">-->
<!--                                <feather-icon icon="ShoppingCartIcon" svgClasses="w-4 h-4" />-->
<!--                                <span class="text-sm ml-2">Envío gratuito</span>-->
<!--                            </span>-->
                        </div>

                        <!-- SLOT: ACTION BUTTONS -->
                        <slot name="action-buttons" />
                    </div>
                </div>
            </div>
        </template>

    </vx-card>
</template>

<script>
/*
import {CldImage} from 'cloudinary-vue';
*/

export default{
  props: {
    item: {
      type: Object,
      required: true
    }
  },
/*
  components: {
    CldImage
  },
*/
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    cloudName() {
      return this.$store.getters['getParameter']('cloudinary').cloudName;
    },
    imagesURL() {
      return this.$store.getters['getParameter']('images').baseURL;
    },
    imageHeight() {
      if (this.windowWidth < 992) {
        return 100;
      } else {
        return 180;
      }
    },
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    },
    onSale() {
      if (this.item.hasOwnProperty('onSale')) {
        return this.item.onSale;
      } else {
        return false;
      }
    }
  },
  methods: {
    additemInCart (item) {
      this.$store.dispatch('eCommerce/additemInCart', item)
    },
    cartButtonClicked (item) {
      this.isInCart(item.code) ? this.$router.push('/checkout').catch(() => {}) : this.additemInCart(item)
    },
    goToItem () {
      this.$router.push({name: 'item-detail-view', params: {item_id: this.item.id }}).catch(() => {})
    },
    getImage(item, height) {
      const imageURL = [this.imagesURL, '/products%2F', item.id, '@', height, '.png?alt=media'].join('');
      return imageURL;
    }
  }
}
</script>

<style lang="scss" scoped>
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
